@include host-component-properties;

.timetable-leg__station_and_platform {
  display: flex;
  column-gap: px-to-rem(var(--paf-global-spacing-fixed-4x));
  margin: 0;
}

.timetable-leg__station {
  font-weight: bold;
  text-wrap: balance;
  hyphens: auto;
  flex-grow: 1;
}

.timetable-leg__platform--changed {
  color: var(--paf-global-post-alert);

  @include forced-colors {
    color: Highlight;
  }
}
